import { css } from 'styled-components';

export const defaultTransition = '0.35s ease-in-out';

export const defaultTransitionCSS = css`
  transition: ${defaultTransition};
`;
